import {FC} from "react";
import {Card} from "react-bootstrap";
import useListSizeOverTime from "@oldDashboard/legacyHooks/useListSizeOverTime";
import ReactApexChart from "react-apexcharts";
import Loader from "@/components/common/loader/loader";

interface ListOverTimeGoalTileProps {  affiliateSelected:String, launchSelected: String, timePeriodSelected: String, searching: boolean }
const ListOverTimeGoalTile: FC<ListOverTimeGoalTileProps> = ({launchSelected, affiliateSelected, timePeriodSelected, searching}) => {
    
    const { isLoading, chartData } = useListSizeOverTime({affiliateSelected, launchSelected, timePeriodSelected, searching});
    if((!chartData?.series && !chartData?.options)) return null;

    return (
        <Card className="custom-card" style={{height: '250px'}}>
            { isLoading && <Loader/> }
            <Card.Header>
                <Card.Title>List Size Over Time</Card.Title>
                &nbsp;<span className="fs-12 text-muted">(Total Students)</span>
            </Card.Header>
            <Card.Body>
                <ReactApexChart
                    options={chartData?.options}
                    series={chartData?.series}
                    type="line"
                    height={175}
                    style={{marginTop: '-25px'}}
            />
            </Card.Body>
        </Card>
    );
};

export default ListOverTimeGoalTile;
